import React from 'react'
import NavigationModel from '../../../../components/CustomNavigation/NavigationModel';
import dayjs from 'dayjs';

const CroIncomeForecastAnalyticsNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const currentDate =dayjs().format('YYYY-MM');
  const redirectUrl = `${phpNavigationUrl}/analytics/cro_income_forecast_analytics/${currentDate}`;
  return (
    <NavigationModel redirectUrl={redirectUrl} title="CRO Income Forecast Analytics" navigationTo={'Old Portal'} />
  );
}

export default CroIncomeForecastAnalyticsNavigation